import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ConfigContext } from '../context/GlobalContext';
import * as actionType from "../context/actions";
import SaleReturnTableDataLayer from './SaleReturnTableDataLayer';
import { Languages } from '../Utils/Languages';
import BusinessDropdown from './child/BusinessDropdown';

const SaleReturnListLayer = ({ businessData, saleReturnData }) => {
    const { state, dispatch } = useContext(ConfigContext);
    const navigate = useNavigate();
    const [selectedBusiness, setSelectedBusiness] = useState("null");

    // ================= PLAN CONFIG =================
    const professionalPlanName = process.env.REACT_APP_PROFESSIONAL_PLAN_NAME;
    const agencyPlanName = process.env.REACT_APP_AGENCY_PLAN_NAME;

    const userPlanName = state?.PAYMENT?.[state?.PAYMENT?.length - 1]?.planName || "Free Plan";
    const isAgencyPlan = userPlanName === agencyPlanName;
    const isProfessionalPlan = userPlanName === professionalPlanName;

    // =================================================

    const sortedBusinesses = [...(state?.BUSINESSES || [])].sort(
        (a, b) => Number(b.creationDate) - Number(a.creationDate)
    );

    // ===========================
    // BUSINESS ACCESS LIMIT
    // ===========================
    let allowedBusinessCount = 1; // Free & Starter

    if (isProfessionalPlan) {
        allowedBusinessCount = 3;
    }

    if (isAgencyPlan) {
        allowedBusinessCount = sortedBusinesses.length;
    }

    const ownBusinesses = sortedBusinesses.filter(b => !b.isShared);
    const sharedBusinesses = sortedBusinesses.filter(b => b.isShared);

    const allowedOwnIds = ownBusinesses
        .slice(-allowedBusinessCount)
        .map(b => String(b.companyId));
    const sharedIds = sharedBusinesses.map(b => String(b.companyId));

    const allAllowedIds = [...allowedOwnIds, ...sharedIds];

    const filteredSaleReturnData = (saleReturnData || []).filter(item =>
        allAllowedIds.includes(String(item.companyId))
    );

    // ===========================
    // DEFAULT SELECTED BUSINESS
    // ===========================
    useEffect(() => {
        if (!businessData?.length) return;

        // "null" means All Businesses is selected
        if (state?.SELECTEDBUSINESS === "null") {
            setSelectedBusiness("null");
            return;
        }

        const selected =
            businessData?.find(b => b?.companyId == state?.SELECTEDBUSINESS)?.companyId ||
            businessData[businessData.length - 1]?.companyId;

        if (selected !== state?.SELECTEDBUSINESS) {
            setSelectedBusiness(selected);
            dispatch({ type: actionType.SELECTEDBUSINESS, payload: selected });
        } else {
            setSelectedBusiness(selected);
        }

    }, [businessData, state?.SELECTEDBUSINESS, dispatch]);

    const handleSelection = (businessId) => {
        setSelectedBusiness(businessId);
        dispatch({ type: actionType.SELECTEDBUSINESS, payload: businessId });
    };

    const handleCreateSaleReturn = () => {
        if (!state?.USERID) {
            dispatch({ type: actionType.GUESTMODELPOPUP, payload: true });
            return;
        }
        navigate("/salereturn-add");
    };

    return (
        <div className="card basic-data-table">
            <div className="card-header d-flex flex-wrap align-items-center justify-content-between gap-3">
                <BusinessDropdown
                    businesses={sortedBusinesses}
                    selectedCompanyId={state?.SELECTEDBUSINESS}
                    onBusinessChange={handleSelection}
                    onPricingNavigate={() => navigate("/pricing")}
                    showAllOption={true}
                    isAllowedCheck={(business) => {
                        if (business === "null") return isAgencyPlan;

                        const ownBusinesses = sortedBusinesses.filter(b => !b.isShared);
                        const allowedOwnIds = ownBusinesses
                            .slice(-allowedBusinessCount)
                            .map(b => b.companyId);

                        return (
                            business.isShared ||
                            isAgencyPlan ||
                            allowedOwnIds.includes(business.companyId)
                        );
                    }}
                />

                {/* <button
                    onClick={handleCreateSaleReturn}
                    className="btn btn-primary-600 bg-primary border-primary px-18 py-11 d-flex align-items-center"
                >
                    <i className="ri-add-line me-2" />
                    {Languages[state?.LANGUAGE]?.SaleReturn_add}
                </button> */}
            </div>

            {/* ================= TABLE ================= */}
            <SaleReturnTableDataLayer
                SaleReturnData={filteredSaleReturnData}
                selectedBusiness={selectedBusiness}
            />
        </div>
    );
};

export default SaleReturnListLayer;
